export default {
	namespaced: true,
	state: {
		loginpop: false,
		showLogin: false,
		isMobileCofirm: {},
		pagePopupData: {},
		playingGamePopup: {
			show: false,
			navigateToCommunity: false
		}
	},
	mutations: {
    // 登录弹窗
		setloginpop(state, value) {
			state.loginpop = value
		},
		setShowLogin(state, value) {
			state.showLogin = value
		},
		setisMobileCofirm(state, data) {
			state.isMobileCofirm = data
		},
		setPagePopupData(state, data) {
			state.pagePopupData = data
		},
		setPlayingGamePopup(state, data = {}) {
			state.playingGamePopup = {
				show: Boolean(data.show),
				navigateToCommunity: Boolean(data.navigateToCommunity)
			}
		},
	}
}